<template>
  <div class="register-page">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <form class="form form--box border" @submit.prevent="submit()" novalidate>
            <h2 class="form__title">ลงทะเบียนผู้ใช้ใหม่</h2>
            <div class="form__item">
              <label class="form__label" for="email">อีเมล</label>
              <input class="form__input" type="email" id="email"  v-model="email" :class="{ 'form__input--error': $v.isError('email') }" />
              <div class="alert alert--error" v-show="$v.$errors.email.empty">กรุณากรอกอีเมล</div>
              <div class="alert alert--error" v-show="!$v.$errors.email.empty && $v.$errors.email.invalid">กรุณากรอกอีเมลให้ถูกต้อง</div>
            </div>
            <div class="form__item">
              <label class="form__label" for="password1">รหัสผ่าน</label>
              <input class="form__input" type="password" id="password1" v-model="password1" :class="{ 'form__input--error': $v.isError('password1') }" />
              <div class="alert alert--error" v-show="$v.$errors.password1.empty">กรุณากรอกรหัสผ่าน</div>
              <div class="alert alert--error" v-show="$v.$errors.password1.minLength">รหัสผ่านต้องยาวไม่น้อยกว่า 6 ตัวอักษร</div>
              <div class="alert alert--error" v-show="$v.$errors.password1.tooEasy">กรุณาใช้รหัสผ่านที่เดายากกว่านี้</div>
            </div>
            <div class="form__item">
              <label class="form__label" for="password2">ยืนยันรหัสผ่าน</label>
              <input class="form__input" type="password" id="password2" v-model="password2" :class="{ 'form__input--error': $v.isError('password2') }" />
              <div class="alert alert--error" v-show="$v.$errors.password2.empty">กรุณากรอกรหัสผ่าน</div>
              <div class="alert alert--error" v-show="!$v.$errors.password2.empty && $v.$errors.password2.unmatched">กรุณากรอกรหัสผ่านให้ตรงกัน</div>
            </div>

            <h3 class="form__title mt-30">ข้อมูลส่วนตัว</h3>

            <div class="form__item mt-30">
              <label class="form__label" for="firstName">ชื่อจริง</label>
              <input class="form__input" type="text" id="firstName" v-model="firstName" :class="{ 'form__input--error': $v.isError('firstName') }" />
              <div class="alert alert--error" v-show="$v.$errors.firstName.empty">กรุณากรอกชื่อของคุณ</div>
            </div>

            <div class="form__item">
              <label class="form__label" for="lastName">นามสกุล</label>
              <input class="form__input" type="text" id="lastName" v-model="lastName" :class="{ 'form__input--error': $v.isError('lastName') }" />
              <div class="alert alert--error" v-show="$v.$errors.lastName.empty">กรุณากรอกนามสกุล</div>
            </div>

            <div class="form__item">
              <label class="form__label" for="telNo">เบอร์โทรศัพท์</label>
              <input class="form__input" type="text" id="telNo" placeholder="0899999999" v-model="telNo" :class="{ 'form__input--error': $v.isError('telNo') }" />
              <div class="alert alert--error" v-show="$v.$errors.telNo.empty">กรุณาระบุเบอร์โทรศัพท์ที่ติดต่อได้</div>
              <div class="alert alert--error" v-show="!$v.$errors.telNo.empty && $v.$errors.telNo.invalid">กรุณากรอกเบอร์โทรให้ถูกต้อง</div>
            </div>

            <button class="btn btn--purple btn--full" :disabled="submitting">ลงทะเบียน</button>
            <router-link to="/user/forgot" class="font-sm">ลืมรหัสผ่าน?</router-link>
            <router-link to="/user/login" class="font-sm fl-right">เข้าสู่ระบบ</router-link>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AddressForm from './AddressForm.vue'

export default {
  components: {AddressForm},
  name: 'LoginPage',
  data () {
    return {
      submitting: false,
      email: '',
      password1: '',
      password2: '',
      firstName: '',
      lastName: '',
      telNo: '',
      $v: null
    }
  },
  created () {
    if (this.$store.state.token) {
      this.$router.push('/')
    }

    this.$v = this.$validator.init(this, {
      email: {
        checkEmpty: true,
        checkEmail: true
      },
      password1: {
        checkEmpty: true,
        minLength: 6,
        checkPassword: true
      },
      password2: {
        checkEmpty: true,
        checkMatch: 'password1'
      },
      firstName: {
        checkEmpty: true
      },
      lastName: {
        checkEmpty: true
      },
      telNo: {
        checkEmpty: true,
        checkPhone: true
      }
    })
  },
  mounted () {
    // load facebook id
    this.$store.dispatch('initFacebookAuth')
  },
  computed: {
    next () {
      return this.$route.query.next || ''
    }
  },
  methods: {
    submit () {
      // cleansing e-mail
      this.email = this.$utils.cleanEmailInvisibleChars(this.email)

      if (this.submitting) {
        return
      }

      if (!this.$v.validate()) {
        this.$forceUpdate()
        return
      }

      this.$forceUpdate()
      this.submitting = true

      const payload = {
        email: this.email.trim(),
        password: this.password1.trim(),
        firstName: this.firstName.trim(),
        lastName: this.lastName.trim(),
        telNo: this.telNo.trim(),
        fbAccessToken: this.$store.state.facebookAuth.accessToken,
        fbUserId: this.$store.state.facebookAuth.userID
      }

      this.$modal.show({
        title: 'โปรดรอสักครู่',
        text: 'กำลังลงทะเบียนผู้ใช้งาน ...',
        okButton: false
      })

      this.$http.post('members/register', payload)
        .then(resp => {
          this.submitting = false
          this.$modal.hide()
          this.$utils.fbTrack('COMPLETED_REGISTRATION', null, {
            REGISTRATION_METHOD: 'Email'
          })

          this.$utils.processLoginResponse(resp)
            .then(() => {
              if (this.next) {
                this.$router.push(`${this.next}`)
              } else {
                this.$router.push('/')
              }
            })
            .catch(err => {
              console.log(err)
              this.$modal.show({
                title: 'ผิดพลาด',
                text: 'ไม่สามารถดึงข้อมูลผู้ใช้ได้ กรุณาทำการ login อีกครั้ง',
                ok: () => {
                  this.$router.push(`/user/login?next=${this.next}`)
                }
              })
            })
        })
        .catch(err => {
          console.log(err)
          this.submitting = false

          let text = 'กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง'
          if (err.body.message.match(/exist/)) {
            text = 'มีอีเมลนี้อยู่แล้ว'
          }

          this.$modal.show({
            title: 'ผิดพลาด',
            text: text
          })
        })
    }
  }
}
</script>

<style scoped>
/*button {
  width: 100%;
}*/
</style>



// WEBPACK FOOTER //
// RegisterPage.vue?69e2bbc8